<div class="flex flex--align-center">
  <mat-form-field>
    <mat-label>{{ 'dairyresults.production.date-picker-placeholder' | translate }}</mat-label>
    <input
      matInput
      disabled
      [matDatepicker]="datepicker"
      [matDatepickerFilter]="dateFilter"
      [value]="selectedDate"
      (dateChange)="onDateChanged($event.value)"
    />
    <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
    <mat-datepicker [dateClass]="datepickerDateClass" #datepicker [disabled]="false">
    </mat-datepicker>
  </mat-form-field>
</div>
